var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHonda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_398",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29007",
    "data-name": "Group 29007",
    transform: "translate(-4265 5094)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4265, -5094)",
    filter: "url(#Ellipse_398)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_398-2",
    "data-name": "Ellipse 398",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-honda",
    transform: "translate(4283.001 -5080)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50583",
    "data-name": "Path 50583",
    d: "M18.033,8a63.238,63.238,0,0,0-8.3.466,7.02,7.02,0,0,0-4.15,1.574,6.674,6.674,0,0,0-1.538,4.526,45.053,45.053,0,0,0,.1,5.549,29.78,29.78,0,0,0,.776,5.431A7.323,7.323,0,0,0,5.9,27.9a4.436,4.436,0,0,0,1.886,1.5,14.7,14.7,0,0,0,5.156.885c1.688.1,3.388.163,5.09.172,1.7-.008,3.4-.071,5.09-.173a14.723,14.723,0,0,0,5.156-.885,4.424,4.424,0,0,0,1.886-1.5,7.366,7.366,0,0,0,.975-2.354,29.59,29.59,0,0,0,.775-5.429,45.206,45.206,0,0,0,.1-5.549,6.675,6.675,0,0,0-1.537-4.525,7.012,7.012,0,0,0-4.15-1.574A63.23,63.23,0,0,0,18.033,8Z",
    transform: "translate(0)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50584",
    "data-name": "Path 50584",
    d: "M29.9,12.435a5.207,5.207,0,0,0-2.946-.987A60.372,60.372,0,0,0,18.928,11a60.19,60.19,0,0,0-8.021.448,5.39,5.39,0,0,0-2.948.987,4.972,4.972,0,0,0-.913,3.152,43.034,43.034,0,0,0,.1,5.29,27.5,27.5,0,0,0,.715,5.043,5.3,5.3,0,0,0,.673,1.685,2.38,2.38,0,0,0,1.012.766,12.062,12.062,0,0,0,4.055.681l.365.022c1.759.1,3.387.16,4.973.167,1.551-.008,3.225-.065,4.954-.168l.376-.023a11.872,11.872,0,0,0,4.043-.681,2.359,2.359,0,0,0,1.013-.768,5.308,5.308,0,0,0,.671-1.683,27.347,27.347,0,0,0,.714-5.043,43.327,43.327,0,0,0,.1-5.289A4.961,4.961,0,0,0,29.9,12.435Z",
    transform: "translate(-0.895 -0.895)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50585",
    "data-name": "Path 50585",
    d: "M25.89,29.14c.54-.032,1.062-.071,1.57-.121a.476.476,0,0,1-.041-.253c.511-3.852.794-7.715,1.037-11.593.072-1.626.165-3.257.189-4.885a3.8,3.8,0,0,1,.015-.74l-.088-.013c-.729-.1-1.476-.173-2.249-.238-.566,2.033-1.219,4.721-1.8,6.76-.467,1.634-1,3.989-3.026,4.2-.3.03-.623.056-.947.06s-.645-.03-.947-.06c-2.024-.21-2.559-2.562-3.026-4.2-.582-2.038-1.234-4.726-1.8-6.759-.773.064-1.519.142-2.247.238l-.089.013a3.85,3.85,0,0,1,.016.739c.023,1.628.117,3.259.189,4.885.242,3.877.525,7.741,1.037,11.593a.654.654,0,0,1-.023.255c.516.052,1.041.091,1.565.121l.365.022c.37.022.73.041,1.09.058.138-.455.76-2.434.76-2.434.483-1.553.47-1.994,1.71-2.235a6.937,6.937,0,0,1,2.714,0c1.241.241,1.321.681,1.8,2.235,0,0,.622,1.975.761,2.433.361-.018.723-.037,1.09-.059Z",
    transform: "translate(-2.518 -0.984)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonda);
export default __webpack_public_path__ + "static/media/honda.6270d07bf92302ee4050c0eeae85581d.svg";
export { ForwardRef as ReactComponent };